import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <div className="prose prose-blue max-w-none">
          <p>
            At Mikhael Homestay, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or stay at our property.
          </p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Information We Collect</h2>
          <p>We may collect personal information that you provide to us, including but not limited to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Name, email address, phone number, and other contact details</li>
            <li>Payment information (processed through secure third-party payment processors)</li>
            <li>Identification information (ID card or passport details as required by local regulations)</li>
            <li>Travel dates and preferences</li>
            <li>Special requests or requirements for your stay</li>
            <li>Feedback and reviews you provide about your experience</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">How We Use Your Information</h2>
          <p>We may use the information we collect for various purposes, including:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Processing and confirming your reservation</li>
            <li>Communicating with you about your stay</li>
            <li>Providing customer service and support</li>
            <li>Processing payments and refunds</li>
            <li>Complying with legal obligations</li>
            <li>Improving our services and guest experience</li>
            <li>Sending promotional emails about special offers or other information (with your consent)</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Information Sharing and Disclosure</h2>
          <p>We may share your information with:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Third-party service providers who assist us in operating our business</li>
            <li>Legal authorities when required by law</li>
            <li>Booking platforms through which you may have made your reservation</li>
          </ul>
          <p>We do not sell, trade, or otherwise transfer your personal information to outside parties without your consent.</p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Cookies and Tracking Technologies</h2>
          <p>
            Our website may use cookies and similar tracking technologies to enhance your experience, analyze usage, and assist in our marketing efforts. You can choose to disable cookies through your browser settings, although this may affect the functionality of our website.
          </p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Your Rights</h2>
          <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>The right to access the personal information we hold about you</li>
            <li>The right to request correction of inaccurate information</li>
            <li>The right to request deletion of your information</li>
            <li>The right to withdraw consent for data processing</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date.
          </p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mb-4">
            Email: mikhaelhomestay@gmail.com<br />
            Phone: +6013-740 8829
          </p>
        </div>
        
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicyPage;
